/**
 * Public surface of the demo engine.
 *
 * `getWorld()` is memoised because the world is expensive to build (28 tokens,
 * ~5k trades, ~700 holders) and because it must be *identical* for the lifetime
 * of the page — two callers getting two worlds would give the explore grid and
 * the token page different prices for the same token.
 */

export * from './types';
export * from './rng';
export * from './curve';
export * from './series';
export * from './world';

import { clearSeriesCache } from './series';
import { generateWorld, type GeneratedWorld } from './world';

export const DEFAULT_SEED = 'bull.markets/v1';

let cached: GeneratedWorld | undefined;
let cachedSeed: string | undefined;

export function getWorld(seed: string = DEFAULT_SEED): GeneratedWorld {
  if (!cached || cachedSeed !== seed) {
    // Series are keyed by token address only, so they have to go with the world.
    clearSeriesCache();
    cached = generateWorld(seed);
    cachedSeed = seed;
  }
  return cached;
}

/** Drops the memoised world. Only useful for tests and the dev seed switcher. */
export function resetWorld(): void {
  cached = undefined;
  cachedSeed = undefined;
  clearSeriesCache();
}
